
import type { IconProps } from 'src/types/icons';

const ImageSliderNextButtonSvg = (props: IconProps) => (
  <svg {...props} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 30L25 20L15 10" stroke="black" strokeOpacity="1" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ImageSliderNextButtonSvg;
